import "./newsNew.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import {
  TextField,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  IconButton,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const NewsNew = ({ title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const { state } = useLocation();
  const newsData = state?.news || {};

  const [formData, setFormData] = useState({
    userId: newsData.userId || userIdRedux,
    newsTitle: newsData.newsTitle || "",
    newsCategory: newsData.newsCategory || "Local",
    newsDescription: newsData.newsDescription || "",
    newsImages: newsData.newsImages || [],
    richText: newsData.newsDescription || "",
  });

  const [newsImages, setNewsImages] = useState(newsData.newsImages || []);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.newsTitle) errors.newsTitle = "Title is required.";
    if (!formData.newsCategory) errors.newsCategory = "Category is required.";
    if (!formData.newsDescription)
      errors.newsDescription = "Description is required.";
    if (newsImages.length === 0)
      errors.newsImages = "Exactly 3 images are required.";
    if (newsImages.length < 3)
      // Changed from 0 to 3
      errors.newsImages = "Select exactly 3 images.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (newsImages.length + files.length > 5) {
      setErrors({
        ...errors,
        newsImages: "You can upload a maximum of 3 images.",
      });
      return;
    }
    setNewsImages([...newsImages, ...files]);
  };

  const removeImage = (index) => {
    setNewsImages(newsImages.filter((_, i) => i !== index));
  };

  const handleDescriptionInputChange = (content, delta, source, editor) => {
    const plainText = editor.getText();
    setFormData((prevState) => ({
      ...prevState,
      newsDescription: plainText.trim(),
      richText: content,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setBackEndError("");

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("newsTitle", formData.newsTitle);
    formDataToSubmit.append("newsCategory", formData.newsCategory);
    formDataToSubmit.append("newsDescription", formData.newsDescription);

    newsImages.forEach((image) => {
      formDataToSubmit.append("newsImages", image);
    });

    const MAIN_URL = newsData._id
      ? `${BASE_URL}/api/news/updateNews/${newsData._id}`
      : `${BASE_URL}/api/news/addNews`;

    try {
      const response = newsData._id
        ? await axios.put(MAIN_URL, formDataToSubmit, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        : await axios.post(MAIN_URL, formDataToSubmit, {
            headers: { "Content-Type": "multipart/form-data" },
          });

      if (response.status === 201 || response.status === 200) {
        setBackEndError(
          <font color="green">
            {response.status === 201
              ? "Success TO ADD DATA."
              : "Success TO UPDATE DATA."}
          </font>,
        );
        navigate("/news");
      } else {
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      }
    } catch (error) {
      setBackEndError(
        <span style={{ color: "red" }}>{error.response.data.msg}</span>,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newNews">
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="newNewsContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{ display: "grid", gap: "1rem", width: "100%" }}
          >
            <Grid item xs={6}>
              <div className="file-upload">
                <input
                  accept="image/*"
                  id="newsImages"
                  type="file"
                  name="newsImages"
                  multiple
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <label htmlFor="newsImages">
                  <IconButton color="primary" component="span">
                    <CloudUploadIcon />
                  </IconButton>
                  <Typography variant="body2">
                    Upload Images (Exactly 3)
                  </Typography>
                </label>

                <div
                  className="image-preview"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    gap: "10px",
                    padding: "5px",
                    maxWidth: "100%",
                  }}
                >
                  {newsImages.map((image, index) => {
                    // 1. Determine the correct URL source
                    let imageSrc = "";
                    if (image instanceof File) {
                      imageSrc = URL.createObjectURL(image);
                    } else if (
                      image &&
                      typeof image === "object" &&
                      image.url
                    ) {
                      imageSrc = image.url; // Extract url from Mongoose object structure
                    } else if (typeof image === "string") {
                      imageSrc = image;
                    }

                    return (
                      <div
                        key={index}
                        className="preview-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={imageSrc} // 2. Use the dynamically resolved imageSrc
                          alt="News"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "10px",
                            objectFit: "cover",
                            marginRight: "10px",
                          }}
                        />
                        <IconButton
                          color="secondary"
                          onClick={() => removeImage(index)}
                        >
                          <Delete />
                        </IconButton>
                      </div>
                    );
                  })}
                </div>
              </div>
              {errors.newsImages && (
                <span className="error-message">{errors.newsImages}</span>
              )}
            </Grid>

            <TextField
              fullWidth
              margin="normal"
              label="Title"
              name="newsTitle"
              value={formData.newsTitle}
              onChange={handleInputChange}
              required
            />

            <FormControl style={{ width: "50%" }} margin="normal">
              <InputLabel>Category</InputLabel>
              <Select
                name="newsCategory"
                value={formData.newsCategory}
                onChange={handleInputChange}
              >
                <MenuItem value="Local">Local</MenuItem>
                <MenuItem value="National">National</MenuItem>
                <MenuItem value="International">International</MenuItem>
              </Select>
            </FormControl>

            <ReactQuill
              theme="snow"
              value={formData.richText}
              onChange={handleDescriptionInputChange}
              placeholder="Write your description here..."
              style={{ height: "250px" }}
            />

            <span className="error-message">{backEndError}</span>

            <div style={{ marginTop: "1rem" }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" /> // Show loading spinner
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsNew;
